<!-- eslint-disable max-len -->
<template>
  <div
    :class="{
      'object-container-automation' : !onProperties,
      'object-active' : blockActive || (!onProperties && id === propertiesIDBlock),
      'object-disabled' : !onProperties && isDisableBlock
    }"
    class="position-relative"
    style="cursor:default"
    @mouseover="pauseZoom"
    @mouseleave="resumeZoom"
  >
    <!-- Disable Block -->
    <div
      v-if="onProperties"
      class="toggle-disable-block"
    >
      <j-switch v-model="disable_block" />

      <!-- Tooltip -->
      <div class="tooltip-toggle-disable">
        {{ disable_block ? 'Disable' : 'Enable' }} this block
      </div>
    </div>

    <template v-if="!onProperties">
      <img
        src="@/assets/new-form-ui/dragged.svg"
        class="icon-drag"
      >
      <img
        :src="require('@/assets/automation/conditional.svg')"
        width="22"
        class="m__r--5">
      <span class="title-automation m__r--5">CONDITIONAL</span>
      <span class="id-block-automation">{{ dataEdit ? `#${dataEdit.id}` : '' }}</span>
    </template>
    <img
      v-if="!onProperties"
      :src="require('@/assets/automation/config.svg')"
      width="20"
      height="20"
      class="pull-right cursor-pointer"
      @click="showProperties">

    <div v-if="onProperties">
      <b-form-group
        :class="{'error-input' : $v.data_conditional.query.$error}"
        class="m__t--15">
        <b-row>
          <b-col md="8">
            <label> Query </label>
          </b-col>
          <b-col
            md="3"
            class="p__r--1">
            <small class="pull-right">Dark Mode</small>
          </b-col>
          <b-col
            md="1"
            class="p__l--1">
            <j-toggle v-model="darkMode"/>
          </b-col>
        </b-row>
        <prism-editor
          v-model="$v.data_conditional.query.$model"
          :highlight="highlighter"
          :line-numbers="true"
          :class="{'dark-mode' : darkMode}"
          class="my-editor"
        />
      </b-form-group>
    </div>
    <div v-else>
      <div class="trigger__label-variable ellipsis m__t--10">
        <img
          :src="require('@/assets/automation/variable.png')"
          width="20"
          height="20"
          class="m__r--10">
        {{ data_conditional.query }}
      </div>
    </div>

  </div>
</template>

<script>
/* eslint-disable max-len, no-unused-vars, no-console, no-nested-ternary */
import { required } from 'vuelidate/lib/validators';
import { mapActions, mapMutations, mapState } from 'vuex';

// Mixins
import jMixPanZoom from '@/mixins/visual-programming/jMixPanZoom';
import jMixAutomation from '@/mixins/visual-programming/jMixAutomation';

import { highlight, languages } from 'prismjs/components/prism-core';
import { PrismEditor } from 'vue-prism-editor';
import jSwitch from '@/components/inputs/jSwitch';
import 'vue-prism-editor/dist/prismeditor.min.css'; // import the styles somewhere

// import highlighting library (you can use any library you want just return html string)
import 'prismjs/components/prism-clike';
import 'prismjs/components/prism-javascript';
import 'prismjs/themes/prism-tomorrow.css';

export default {
  name: 'JAutomationConditional',
  components: {
    PrismEditor,
    jSwitch,
  },
  mixins: [
    jMixPanZoom,
    jMixAutomation,
  ],
  props: {
    id: {
      type: Number,
      default: 0,
    },
    dataIndex: {
      type: Number,
      default: 0,
    },
    dataIndexParent: {
      type: Number,
      default: 0,
    },
    dataPosition: {
      type: String,
      default: '',
    },
    dataEdit: {
      type: Object,
      default: () => {},
    },
    onProperties: {
      type: Boolean,
      default: false,
    },
    isActive: {
      type: Boolean,
      default: false,
    },
    row: {
      type: Number,
      default: 0,
    },
    dataParent: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      data_conditional: {
        query: '',
        is_disable: false,
      },
      disable_block: false,
      darkMode: false,
      blockActive: false,
      blockError: false,
    };
  },
  computed: {
    ...mapState('jStoreAutomation', ['propertiesOpened', 'propertiesIDBlock']),
  },
  watch: {
    dataEdit() {
      this.setValueOnProperties();

      // Set disable block according to parent
      this.updateIsDisableBlock();
    },

    propertiesOpened(val) {
      if (!val) this.blockActive = false;
    },

    // eslint-disable-next-line func-names
    'data_conditional.is_disable': function (val) {
      this.disable_block = !val;
    },

    disable_block(val) {
      this.data_conditional.is_disable = !val;
    },
  },
  created() {
    this.setValueOnProperties();
  },
  mounted() {
    // Set disable block according to parent
    this.updateIsDisableBlock();
  },
  methods: {
    ...mapMutations('jStoreAutomation', ['setPropertiesOpened']),

    setValueOnProperties() {
      this.data_conditional.query = this.dataEdit && this.dataEdit.conditional ? this.dataEdit.conditional.query : '';
      this.blockError = false;
      this.data_conditional.is_disable = this.dataEdit && this.dataEdit.is_disable;
      this.disable_block = !this.data_conditional.is_disable;
    },

    highlighter(code) {
      return highlight(code, languages.js); // returns html
    },

    validateData() {
      this.$v.data_conditional.$touch();
      return this.$v.data_conditional.$error;
    },

    getData() {
      return new Promise((resolve, reject) => {
        if (!this.validateData()) {
          const data = {
            type: 'conditional',
            conditional: {
              query: this.data_conditional.query,
              action_true: [],
              action_false: [],
            },
            is_disable: this.data_conditional.is_disable,
          };
          if (this.dataEdit && this.dataEdit.id) data.id = this.dataEdit.id;
          resolve(data);
        } else {
          reject(null);
        }
      });
    },

    showProperties() {
      if (this.propertiesOpened) {
        this.setPropertiesOpened({
          open: false,
        });

        setTimeout(() => {
          this.blockActive = true;
          this.setPropertiesOpened({
            open: true,
            type: 'conditional',
            data: this.dataEdit,
            index: this.dataIndex,
            row: this.row,
            dataParent: this.dataParent,
            idBlock: this.id,
          });
        }, 100);
      } else {
        this.blockActive = true;
        this.setPropertiesOpened({
          open: true,
          type: 'conditional',
          data: this.dataEdit,
          index: this.dataIndex,
          row: this.row,
          dataParent: this.dataParent,
          idBlock: this.id,
        });
      }
    },

    setErrorBlock() {
      this.blockError = true;
    },

    clearErrorBlock() {
      this.blockError = false;
    },
  },
  validations() {
    return {
      data_conditional: {
        query: {
          required,
        },
      },
    };
  },
};
</script>



// WEBPACK FOOTER //
// src/views/visual-programming/jVPBlockConditional.vue